import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { Book } from './book.model';
import { BooksStore } from './books.store';
import { AppConfigQuery } from '../../../../core/state/app-config/app-config.query';
import { throwError } from 'rxjs';
import { applyTransaction } from '@datorama/akita';

@Injectable({ providedIn: 'root' })
export class BooksService {
    constructor(
        private appConfig: AppConfigQuery,
        private booksStore: BooksStore,
        private http: HttpClient
    ) {}

    get() {
        return this.http
            .get<Book[]>(`${this.appConfig.get().accountingBaseUrl}/accounting/v1/books`)
            .pipe(
                tap((entities) => {
                    this.booksStore.set(entities);
                }),
                catchError((error) => {
                    applyTransaction(() => {
                        {
                            this.booksStore.setError(error);
                            this.booksStore.setLoading(false);
                        }
                    });
                    return throwError(error);
                })
            );
    }

    add(book: Omit<Book, 'id'>) {
        return this.http
            .post<Book>(
                `${this.appConfig.get().accountingBaseUrl}/accounting/v1/book`,
                book
            )
            .pipe(
                tap((book) => {
                    this.booksStore.upsert(book.id, book);
                })
            );
    }

    update(id: Book['id'], book: Partial<Book>) {
        this.booksStore.update(id, book);
    }

    remove(id: Book['id']) {
        return this.http
            .delete<Book>(
                `${this.appConfig.get().accountingBaseUrl}/accounting/v1/book/${id}`
            )
            .pipe(
                tap((book) => {
                    this.booksStore.remove(id);
                })
            );
    }

    setActive(id: Book['id']) {
        this.booksStore.setActive(id);
    }
}
